import { Route, Routes, Navigate } from "react-router-dom";
import Home from "./Components/Home";

import StaffDetails from "./Components/StaffDetails";
import AdmissionComponent from "./Components/Admissions";
import AboutUs from './Components/AboutUs';
import Facilities from './Components/Facilities';
import Careers from "./Components/Careers";
import College from "./Components/College";
import CustomPage from "./Components/CustomPage";
import { colleges } from "./data/colleges";

const AppRoutes = () => {
    return (
        <div>
            <Routes>
                <Route>
                    <Route exact path="/" Component={Home} />
                    <Route path="/home" Component={Home} />

                    {/* one page per college, driven by src/data/colleges.js */}
                    <Route path="/colleges/:slug" Component={College} />
                    <Route
                        path="/colleges"
                        element={<Navigate to={`/colleges/${colleges[0].slug}`} replace />}
                    />

                    <Route path="/staff" Component={StaffDetails} />
                    <Route path='/admissions' Component={AdmissionComponent}/>
                    <Route path='/about-us' Component={AboutUs}/>
                    <Route path='/facilities' Component={Facilities}/>
                    <Route path="/careers" Component={Careers}></Route>

                    {/* CMS-authored custom pages */}
                    <Route path="/p/:slug" Component={CustomPage} />

                    <Route path="*" element={<Navigate to="/home" />} />
                </Route>
            </Routes>
        </div>
        )
}

export default AppRoutes;
